import React, { useState } from "react"

import SEO from "../components/common/SEO"
import GalleryGrid from "../components/gallery/GalleryGrid"
import Lightbox from "../components/gallery/Lightbox"

export default function Gallery() {
  const images = [
    { id: 1, src: "/images/gallery-1.jpg", title: "Chambre Massage Luxe" },
    { id: 2, src: "/images/gallery-2.jpg", title: "Experience Hammam" },
    { id: 3, src: "/images/gallery-3.jpg", title: "Soins Visage" },
    { id: 4, src: "/images/gallery-4.jpg", title: "Espace Détente" },
    { id: 5, src: "/images/gallery-5.jpg", title: "Piscine Intérieur" },
    { id: 6, src: "/images/rituel.jpg", title: "Thérapie de Bien-être" },
    { id: 7, src: "/images/gallery-7.jpg", title: "Salle de Remise En Forme" },
    { id: 8, src: "/images/gallery-8.jpg", title: "Soins des Ongles" },
  ]

  const [currentIndex, setCurrentIndex] = useState(null)

  return (
    <>
      {/* SEO */}
      <SEO
        title="Galerie Centre Spa Land Saphir Palace Hammamet Tunisia | Expérience de Bien-être de Luxe"
        description="Découvrez notre galerie de spa de luxe présentant nos salles de massage, notre hammam, nos soins du visage et nos espaces de détente."
        keywords="Galerie de photos de spa, hammams, images de spas de massage, centres de bien-être en Tunisie"
        url="https://www.yourdomain.com/gallery"
      />

      <main className="overflow-x-hidden">
{/* Hero */}
<section className="py-20 lg:py-28 bg-[#f9f6f1] text-center">
  <h1 className="text-4xl md:text-5xl font-bold text-[#111111]">
    Notre Galerie de Spa
  </h1>

  <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
    Découvrez l'atmosphère paisible et l'expérience luxueuse de notre centre de spa.
  </p>
</section>

{/* Video */}
<section className="bg-[#f9f6f1] pb-20">
  <div className="max-w-6xl mx-auto px-4">
    <div className="text-center mb-8">
      <h2 className="text-3xl font-bold text-[#111111]">
        Découvrez Notre Spa
      </h2>

      <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
        Une courte vidéo de l'extérieur du Centre Spa Land Vincci Saphir Palace
        pour vous permettre de reconnaître facilement notre établissement avant votre visite.
      </p>
    </div>

    <div className="overflow-hidden rounded-3xl shadow-2xl">
      <video
        className="w-full"
        controls
        playsInline
        preload="metadata"
      >
        <source src="/videos/spa.mp4" type="video/mp4" />
        Votre navigateur ne prend pas en charge la lecture des vidéos.
      </video>
    </div>
  </div>
</section>

{/* Gallery */}
<GalleryGrid />

        {/* Lightbox */}
        <Lightbox
          images={images}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
        />
      </main>
    </>
  )
}